<template>
    <div class="h-100 d-flex flex-column" v-bind:style="{'margin-top:60px;':is_ios}">
        <transition name="fade">
            <p class="progress-text fixed-top text-center" v-show="show_progress">
                {{$t('step_scene', {progress: progress_text, length: length_text})}}
            </p>
        </transition>
        <div class="video-player-container flex-row granted">
            <video ref="playbackVideo" playsinline class="video-player"></video>
            <div v-if="loading" class="video-player-overlay d-flex justify-content-center"><div class="align-self-center"><i class="fa fa-circle-o-notch fa-spin fa-fw"></i><br/>Bezig met laden...</div></div>
            <div v-if="!loading && !playing && !played" class="video-player-overlay d-flex justify-content-center" @click="playVideo()"><div class="align-self-center"><i class="fa fa-play-circle-o"></i></div></div>
        </div>
        <div class="recorder-overlay">
            <sequence-recorder ref="recorder" :can-stop="true"></sequence-recorder>
            <button v-if="display_next" @click="next" class="btn btn-lg btn-secondary"><i class="fa fa-arrow-circle-right fa-fw"></i> {{$t('next')}}</button>
        </div>
    </div>
</template>

<script>
    import SequenceRecorder from '@/views/sequence/Recorder';
    import { detect } from 'detect-browser';

    export default {
        components: { SequenceRecorder },
        data() {
            return {
                test: 0,
                playing: false,
                played: false,
                loading: true,
                display_next: false,
                show_progress: false,
                progress_text: 0,
                length_text: 0,
                sequence_progress: -1,
            }
        },
        computed: {
            is_ios() {
                return detect().name === 'ios';
            }
        },
        mounted() {
            let count = 0;

            // Count clips that need recording
            for(let i in this.$state.login_info.clipinfo) {
                if(this.$state.login_info.clipinfo[i].mustrecord === 1)
                    count++;
            }

            this.length_text = count;
            this.next();
        },
        methods: {
            /**
             * Reset some states so a new video can be played.
             */
            reset() {
                this.loading = true;
                this.display_next = false;
                this.playing = false;
                this.played = false;
                this.$refs.playbackVideo.src = "";
            },
            /**
             * Load a video from the server.
             * @param {Number} index The index needs to be in `$state.login_info.clipinfo`.
             */
            start(index) {
                this.reset();

                let video = this.$refs.playbackVideo;
                let sequence = this.$state.login_info.clipinfo[index];

                if(sequence.mustrecord === 1)
                    this.show_progress = true;

                let timer = null;
                this.log('Loading sequence');
                this.log(sequence);

                this.loading = true;

                video.onplay = () => {
                    setTimeout(() => {
                        this.show_progress = false;
                    }, 5000);

                    this.playing = true;
                };

                video.onended = () => {
                    if(timer) {
                        clearInterval(timer);
                    }
                    this.playing = false;
                    this.played = true;
                    if(this.$state.login_info.clipinfo[this.sequence_progress].mustrecord === 0) {
                        this.display_next = true;
                    } else {
                        this.startRecording(this.$state.login_info.maxresponstijd * 1000);
                    }
                };

                let url = this.$state.login_info.uitdagingurl + sequence.url.replace('mp3', 'mp4');

                this.fetchVideo(url).then(blob => {
                    // Create a source for the video element from the blob.
                    video.src = URL.createObjectURL(blob);

                    this.loading = false;
                    this.playing = true;
                    this.playVideo().catch(error => {
                        this.playing = false;
                    });
                })
                .catch(err => {
                    this.log('Unable to fetch video: ' + err.message);
                });

            },
            fetchVideo(url) {
                return new Promise((resolve, reject) => {
                    // Usual XMLHttpRequest setup.
                    var request = new XMLHttpRequest();
                    request.open('GET', url);
                    request.responseType = 'blob';

                    request.onload = function() {
                        // Check if request status code was successful.
                        if (request.status === 200) {
                            // Resolve with request response.
                            resolve(request.response);
                        } else {
                            // Otherwise reject with a meaningfull message.
                            reject(new Error(req.statusText));
                        }
                    };

                    // Handle any network errors.
                    request.onerror = e => {
                        this.log(e);
                        reject(new Error('Network error'+e));
                    };

                    // Send request.
                    request.send();
                });
            },
            /**
             * Play the video. Cannot be replayed once it has been played once.
             */
            playVideo() {
                if(!this.played) {
                    return this.$refs.playbackVideo.play();
                }
            },
            /**
             * Start recording.
             * @param {Number} ms Max duration
             * @return {Promise}
             */
            startRecording(ms) {
                return this.$refs.recorder.record(ms)
                    .then((recordedChunks) => {
                        this.upload(recordedChunks);
                        this.display_next = true;
                    });
            },
            /**
             * Upload recorded chunks to server.
             * @param {Array} recordedChunks
             * @return {Promise}
             */
            upload(recordedChunks) {
                let sequence = this.$state.login_info.clipinfo[this.sequence_progress];
                return this.$api.uploadVideo(recordedChunks, sequence.opslagnaam, false);
            },
            /**
             * Go one step next in the sequence and start the new video.
             * @return {Boolean}
             */
            next() {
                let clipinfo;
                do {
                    this.sequence_progress++;

                    if(this.sequence_progress >= this.$state.login_info.clipinfo.length) {

                        this.$router.push({name: 'sequenceDone'});
                        return false;
                    }

                    clipinfo = this.$state.login_info.clipinfo[this.sequence_progress];

                    if(clipinfo.mustrecord === 1)
                        this.progress_text++;
                }
                while((clipinfo.mustrecord === 1 && clipinfo.reactionfoundonserver === 1) ||
                (clipinfo.mustrecord === 0 && this.$state.login_info.restartdetected === 1));

                this.start(this.sequence_progress);
                return true;
            }
        }
    }
</script>
